module.exports = __webpack_public_path__ + "img/support-Zs.9bb48713.svg";